export default {
  parseStringForTri (data) {
    if (data === null) { return null }
    const k = data.replaceAll(/[\\]/g, 'ṭ').replaceAll(/[|]/g, 'Ṭ')
    return k
  }
}
